module.exports = __webpack_public_path__ + "static/media/screenshot-8.ae75e526.png";